import styled from 'styled-components';

const Container = styled.div.withConfig({
  componentId: 'popup-effect_container',
  displayName: 'PopupEffect.Container',
})`
  position: absolute;

  &.is-positioned {
    animation: fadeInAndScale 0.2s ease-out forwards;
  }

  @keyframes fadeInAndScale {
    from {
      opacity: 0;
      transform: scale(0.98);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  &.is-not-positioned {
    left: 100vw;
    top: 100vh;
    width: max-content;
  }
`;

export const PopupEffectStyle = {
  Container,
};
